import { DefaultEditor, ViewCell } from 'ng2-smart-table';
import { Component, OnInit } from '@angular/core';
import { CustomEventService } from './customEventService';
import { CustomFormUtilsService } from './../../custom-form-utils.service';
import { ChangeDetectorRef } from '@angular/core';


/**
 * Componente que renderiza la celda Valor Traducido en la tabla de customform
 */
@Component({
  template: `
            <p>{{this.valorTraducidoEvent}}</p>
  `,
})
export class ValorTraducidoEventComponent extends DefaultEditor implements OnInit {

  constructor (private customFormUtilsService:CustomFormUtilsService,
    private customeventservice: CustomEventService,
    private cdr: ChangeDetectorRef)
  {
    super();
  }

  valorTraducidoEvent: any;
  rowData: any;
  evento:String;

  async ngOnInit() {
    let vResul = await this.customeventservice.validaExpresion(this.rowData.event)
    this.valorTraducidoEvent = vResul.vTraduccion
    this.evento = this.rowData.event;
    this.cdr.detectChanges(); // Forzar la detección de cambios
  }

}

